import { Link } from "react-router-dom";
import study from "../../../image/Time management-amico.svg";

export default function Index() {
    return (
        <div className="flex flex-col justify-center items-center min-h-screen px-4 md:px-8 py-6 bg-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-[1600px] items-center">

                {/* Colonne gauche : images style carte flottante */}
                <div className="relative flex justify-center items-center">
            
                    {/* Carte Salle */}
                    <div className=" p-4 md:p-6 ">
                        <img
                            src={study}
                            alt="Salle"
                            className="w-[90vw] md:w-[700px] lg:w-[800px] h-auto rounded-2xl"
                        />
                    </div>
                </div>

                {/* Colonne droite : texte */}
                <div className=" p-6 md:p-10 rounded-3xl flex flex-col justify-center space-y-6 text-center md:text-left">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#5B345B] leading-tight">Gestion des Catalogues</h1>
                    <p className="text-lg md:text-2xl text-gray-700">Bienvenue dans votre espace!</p>
                    <p className="text-lg md:text-2xl text-gray-700">Ici, vous pouvez organiser vos modules, diffuser les informations et mettre à jour votre offre</p>
                    <div className="flex justify-center md:justify-start">
                        <Link
                            to="/login"
                            className="inline-flex items-center justify-center px-6 py-3 text-lg md:text-xl font-bold rounded-full bg-[#5B345B] text-white shadow-lg hover:bg-[#472747] transition-all"
                        >
                             Commencer la gestion
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    );
}
